import { ShieldCheck, AlertTriangle, Footprints } from "lucide-react";
import { useCmsContent, renderMarkers } from "@/lib/cms";
import SeoCopy from "@/components/SeoCopy";

export default function Rules() {
  const { c } = useCmsContent("rules");
  const allowed = c["rules.allowed"] || [];
  const notAllowed = c["rules.not_allowed"] || [];
  const safety = c["rules.safety"] || [];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-fredoka text-3xl sm:text-4xl font-bold text-slate-900" data-testid="rules-title">{c["rules.title"]}</h1>
      <p className="text-slate-600 mt-2">{c["rules.subtitle"]}</p>

      <div className="grid sm:grid-cols-2 gap-4 mt-6">
        <div className="card-clay p-6 bg-green-50 border-green-200">
          <div className="flex items-center gap-2 text-green-800">
            <ShieldCheck strokeWidth={2.5}/>
            <h2 className="font-fredoka font-bold text-lg">We pick up</h2>
          </div>
          <ul className="mt-3 space-y-2 text-sm text-green-900 list-disc list-inside" data-testid="rules-allowed">
            {allowed.map((a, i) => <li key={i} dangerouslySetInnerHTML={{ __html: renderMarkers(a) }}/>)}
          </ul>
        </div>
        <div className="card-clay p-6 bg-red-50 border-red-200">
          <div className="flex items-center gap-2 text-red-800">
            <AlertTriangle strokeWidth={2.5}/>
            <h2 className="font-fredoka font-bold text-lg">We don't pick up</h2>
          </div>
          <ul className="mt-3 space-y-2 text-sm text-red-900 list-disc list-inside" data-testid="rules-notallowed">
            {notAllowed.map((a, i) => <li key={i} dangerouslySetInnerHTML={{ __html: renderMarkers(a) }}/>)}
          </ul>
        </div>
      </div>

      <div className="card-clay p-6 mt-6">
        <div className="flex items-center gap-2">
          <Footprints className="text-green-600" strokeWidth={2.5}/>
          <h2 className="font-fredoka font-bold text-lg">Safety promise</h2>
        </div>
        <ul className="mt-3 space-y-2 text-sm text-slate-700 list-disc list-inside">
          {safety.map((s, i) => <li key={i} dangerouslySetInnerHTML={{ __html: renderMarkers(s) }}/>)}
        </ul>
      </div>
      <SeoCopy
        title="Why these rules?"
        links={[
          { to: "/about", label: "Meet the Kids" },
          { to: "/policies", label: "Pricing & policies" },
          { to: "/schedule", label: "Schedule a pickup" },
          { to: "/contact", label: "Ask a question" },
        ]}
      >
        <p>Bag Dash Kids is a <strong>youth-led, parent-supervised</strong> business. To keep Big Sib Josiah and Lil Sib Jayla safe and to protect your home, we only pick up tied household trash bags that are placed outside in your agreed pickup spot. We don&apos;t handle hazardous materials, sharp items, broken glass (unless safely boxed and labeled), leaking bags, loose trash, or oversized items.</p>
        <p>The kids never enter homes, garages, or private indoor spaces. A parent or guardian oversees every pickup window. If something falls outside our rules, we&apos;ll leave the bag in place and message you — no extra charge.</p>
      </SeoCopy>
    </div>
  );
}
